import { HttpClientModule } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { AboutModule } from './about/about.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HomeModule } from './home/home.module';
import { ApisModule } from './apis/apis.module';
import { ConfigurationService } from './core/configuration.service';
import { UserService } from './core/user/user.service';

export function getConfiguration(configurationService: ConfigurationService, userService: UserService) {
  return () => configurationService.getConfigurationPromise()
    .then(() => {
      return userService.init();
    });
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    HttpClientModule,
    AboutModule,
    AppRoutingModule,
    HomeModule,
    ApisModule,
    MDBBootstrapModule.forRoot(),
  ],
  providers: [
    ConfigurationService,
    { provide: APP_INITIALIZER, useFactory: getConfiguration, deps: [ConfigurationService, UserService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
